import type { Translation } from "../i18n-types.js"

const pt = {
  common: {
    countViews: "{{nenhuma visualização|1 visualização|?? visualizações}}",
    countReactions: "{{nenhuma reação|1 reação|?? reações}}",
    back: "Voltar",
    blog: "Posts",
    settings: "Configurações",
    addPosts: "criar post",
    save: "Guardar",
    filter: "Filtrar",
    tag: "Etiqueta",
    sort: "Ordenar",
    all: "Todos",
    loading: "Carregando...",
    saving: "Guardando...",
    delete: "Apagar",
    edit: "Editar",
    close: "Fechar",
    error: "Erro ao salvar dados",
    networkError: "Erro ao salvar dados. Por favor, verifique sua conexão",
    validationError: "Por favor, revise o formulário",
    by: "por",
    cancel: "Cancelar",
    private: "Privado",
    holdToConfirm: "Mantém para confirmar",
    done: "Feito!",
    defaultLanguage: "predefinido",
    translating: "Traduzindo...",
    translateAll: "Traduzir tudo",
    translateFrom: "Traduzir de {language}",
  },
  mainLayout: {
    errorLoadingData: "Ocorreu um erro ao carregar os dados desta página. Por favor, tente novamente.",
    reloadPage: "Recarregar página",
  },
  dashboard: {
    welcomeBack: "Bem-vindo de volta",
    latestPosts: "Posts mais recentes",
    viewAllPosts: "Ver todos os posts",
    noPostsYet: "Você ainda não publicou nenhum post.",
    latestDrafts: "Rascunhos mais recentes",
    viewAllDrafts: "Ver tudo",
    noDrafts: "Você não tem nenhum rascunho",
    latestNotes: "Notas mais recentes",
    noNotesYet: "Você ainda não tem nenhuma nota",
    subscribers: "Assinantes",
    posts: "Posts",
    views: "Visualizações",
    openRate: "Taxa de abertura",
    published: "Publicado",
    created: "Criado",
    recentReactions: "Reações recentes",
    noReactionsYet: "Você ainda não tem reações",
    reactedToYourPost: "reagiram à sua publicação",
    othersCount: "{{nenhuma outra|1 outra pessoa|?? outras pessoas}}",
    createPublication: {
      title: "Crie sua própria publicação",
      description: "Comece seu próprio canto na web. compartilhe seus pensamentos, construa sua audiência e possua seu conteúdo.",
      button: "Começar",
    },
    verifyEmail: {
      title: "Verifique seu email",
      description: "Verifique seu endereço de email para desbloquear todas as funcionalidades, como criar sua própria publicação.",
      button: "Verificar email",
    },
  },
  settings: {
    title: "Configurações",
    localizationTitle: "Idioma",
    localizationDescription: "Defina o idioma que prefere",
    interfaceLanguageLabel: "Idioma da interface",
    authenticationTitle: "Autenticação",
    authenticationDescription: "Gerencie a sua conta",
    signedInAs: "Conectado como {email}",
    signOut: "Sair",
    signingOut: "Saindo...",
    authorProfileTitle: "Perfil de autor",
    authorProfileDescription: "Informações sobre você que serão exibidas na sua publicação",
    profileImageLabel: "Foto de perfil (120×120)",
    authorNameLabel: "Nome do autor",
    authorNamePlaceholder: "Seu nome",
    bioLabel: "Bio",
    bioPlaceholder: "Conte aos seus leitores sobre você",
    imageSaved: "Imagem carregada",
    imageDeleted: "Imagem eliminada",
    informationSaved: "Salvo com sucesso",
    social: {
      title: "redes sociais",
      description: "conecte seus perfis sociais à sua publicação",
      social_x: {
        label: "X (Twitter)",
        placeholder: "https://x.com/nomedeusuario",
      },
      social_instagram: {
        label: "Instagram",
        placeholder: "https://instagram.com/nomedeusuario",
      },
      social_tiktok: {
        label: "TikTok",
        placeholder: "https://tiktok.com/@nomedeusuario",
      },
      social_youtube: {
        label: "YouTube",
        placeholder: "https://youtube.com/@nomedeusuario",
      },
      social_facebook: {
        label: "Facebook",
        placeholder: "https://facebook.com/nomedeusuario",
      },
      social_linkedin: {
        label: "LinkedIn",
        placeholder: "https://linkedin.com/in/nomedeusuario",
      },
      social_bluesky: {
        label: "Bluesky",
        placeholder: "https://bsky.app/profile/nomedeusuario",
      },
      social_books: {
        label: "Livros",
        placeholder: "https://goodreads.com/user/show/nomedeusuario",
      },
      social_website: {
        label: "Site",
        placeholder: "https://seusite.com",
      },
      social_soundcloud: {
        label: "SoundCloud",
        placeholder: "https://soundcloud.com/nomedeusuario",
      },
      social_bandcamp: {
        label: "Bandcamp",
        placeholder: "https://nomedeusuario.bandcamp.com",
      },
    },
    subscriptions: {
      empty: "Você ainda não tem assinaturas",
      unsubscribeTitle: "Cancelar assinatura",
      unsubscribeDescription: "Você não receberá mais atualizações desta publicação.",
      unsubscribePaidDisclaimer: "O seu plano pago atual também será cancelado.",
      holdToUnsubscribe: "Mantém para cancelar",
      unsubscribing: "Cancelando...",
      unsubscribed: "Assinatura cancelada",
    },
    deleteAccount: {
      title: "Eliminar conta",
      description: "Eliminar permanentemente a sua conta e todos os dados",
      warning: "Esta ação não pode ser desfeita. Todas as publicações, notas e dados de assinantes serão eliminados permanentemente.",
      button: "Eliminar conta",
      confirmTitle: "Eliminar a sua conta?",
      confirmDescription: "Isto eliminará permanentemente a sua conta e todo o conteúdo. Esta ação não pode ser desfeita.",
      exportBeforeDeletePrefix: "Antes de eliminar, pode",
      exportBeforeDeleteSuffix: "os dados da sua publicação, incluindo todas as publicações, notas e informações de assinantes.",
      typeToConfirm: "Digite {text} para confirmar",
      confirmButton: "Eliminar a minha conta",
    },
  },
  post: {
    preview: "pré-visualização",
    previewDescription: "Veja como sua publicação apareceria para seus leitores.",
    unarchive: "desarquivar",
    update: "atualizar",
    updated: "Publicação atualizada com sucesso",
    publish: "Continuar",
    uploadHeaderImage: "Enviar imagens de cabeçalho (16:9, 800 × 450 px)",
    title: "Título",
    subtitle: "Subtítulo",
    statusSpam: "Esta versão foi marcada como spam, entre em contato com o suporte se achar que isso é um erro.",
    statusArchived: "Esta versão está arquivada, as pessoas não podem vê-la, mas você ainda pode editá-la.",
    statusSent: "Esta versão foi enviada aos seus assinantes por e-mail",
    statusPublished: "Esta versão está publicada e visível para os seus leitores",
    statusDraft: "Esta é uma versão de rascunho, você pode visualizá-la na prévia, mas ela não está visível para os seus leitores",
    words: "palavras",
    savedAt: "Guardado às {time}",
    notes: "Notas",
    notesDescription: "Crie e fixe notas neste post.",
    proofread: "Revisar",
    proofreadDescription: "Obtenha ajuda para melhorar a clareza e o engajamento do seu post.",
    versions: "Versões",
    settings: "Configurações",
    settingsDescription: "Configure sua publicação.",
    translations: "Traduções",
    alsoIn: "Também em",
    translationsDescription: "Traduza seu post automaticamente para outros idiomas. Alcance mais leitores.",
    share: "Compartilhar",
    shareDescription: "Obtenha um link para compartilhar seu post nas redes sociais.",
    focusMode: "Modo foco",
    focusModeDescription: "Transforme o editor em um modo sem distrações para que você possa se concentrar na sua escrita.",
    translationOutdated: "Esta tradução foi feita para uma versão anterior",
    mainLanguage: "Idioma principal",
    alternativeLanguages: "Idiomas alternativos",
    alternativeLanguagesDescription: "Ative as traduções para o seu post. Ative os idiomas para gerá-los ou desative-os para removê-los.",
    translationsSaved: "Traduções salvas com sucesso",
    translationOutdatedMessage: "Esta tradução está desatualizada.",
    translationUpToDate: "Esta tradução está atualizada.",
    regenerateTranslation: "Atualizá-la",
    translationOutdatedOr: "Ou",
    markTranslationAsUpdated: "Marcar como atualizada",
    updatingTranslation: "Atualizando tradução...",
    translationRegenerated: "Tradução atualizada com sucesso",
    saveChanges: "Salvar alterações",
    saveAndGenerate: "Salvar e gerar",
    saveAndDelete: "Salvar e excluir",
    publishPage: {
      update: "Atualizar",
      publish: "Publicar",
      delivery: "Entrega",
      deliveryDescription: "Como você quer entregar esta publicação?",
      sendViaEmail: "Enviar por e-mail",
      alreadySent: "Você já enviou esta publicação aos seus assinantes por e-mail em {date}",
      subscribersWillReceive: "{{Nenhum assinante|1 assinante|?? assinantes}} receberão esta publicação em suas caixas de entrada.",
      sendTestToMyself: "Enviar teste para mim mesmo",
      testEmailSent: "E-mail de teste enviado com sucesso",
      testEmailError: "Falha ao enviar e-mail de teste",
      audienceTitle: "Público",
      audienceDescription: "Escolha quem pode ver esta publicação.",
    },
  },
  editor: {
    defaultPlaceholder: "Escreva algo…",
    highlightColor: "Cor de destaque",
    noHighlight: "Sem destaque",
    grey: "Cinza",
    yellow: "Amarelo",
    blue: "Azul",
    green: "Verde",
    orange: "Laranja",
    red: "Vermelho",
    bulletList: "Lista com marcadores",
    orderedList: "Lista numerada",
    image: "Imagem",
    code: "Código",
    quote: "Citação",
    subscribe: "Assinar",
    imageTitlePlaceholder: "Título da imagem",
    imageDescriptionPlaceholder: "Descrição para acessibilidade",
    imageSizeSmall: "Pequeno",
    imageSizeMedium: "Médio",
    imageSizeBig: "Largura total",
    turnIntoLabel: "Transformar em...",
    heading1: "Título 1",
    heading2: "Título 2",
    heading3: "Título 3",
    blockquote: "Citação",
    text: "Texto",
    callout: "Destaque",
    bold: "Negrito",
    italic: "Itálico",
    strikethrough: "Tachado",
    inlineCode: "Código inline",
    highlight: "Destaque",
    link: "Link",
    horizontalRule: "Divisor",
    undo: "Desfazer",
    redo: "Refazer",
    insertBlock: "Inserir bloco",
    more: "Mais",
    snippet: "Snippet",
    codeBlock: "Bloco de código",
    math: "Math",
    embed: "Embed",
    embedDisplay: "Exibição",
    embedDisplayEmbed: "Interativo",
    embedDisplayCard: "Cartão",
    language: "Idioma",
  },
  notes: {
    newNote: "Nova nota",
    cancel: "cancelar",
    noPinnedYet: "ainda não há notas",
    voice: "voz",
    copyToPost: "copiar para o artigo",
  },
  blog: {
    title: "Publicação",
    audience: "Audiência",
    forms: "Forms",
    stats: "Estatísticas",
    noResultsFound: "Nenhum resultado encontrado",
    noPostsYet: "Você ainda não criou nenhum post.",
    filter: {
      spam: "Spam",
      archived: "Arquivado",
      sent: "Enviado",
      published: "Publicado",
      draft: "Rascunho",
    },
    blogName: "Nome da publicação",
    blogNameDescription: "Defina o nome da sua publicação: ele será usado para identificar a publicação e gerar a URL",
    atLeast3Characters: "Use de 3 a 15 caracteres: letras, números ou hífens.",
    nameAvailable: "Este nome está disponível.",
    nameInvalid: "Este nome é inválido.",
    nameUnavailable: "Este nome já está em uso.",
    nameNaughty: "Este nome não é permitido.",
    nameChangeCooldown: "Você poderá alterar seu nome em {days} {{dia|dias}}.",
    nameChangeWarning: "Após a alteração, você não poderá mudar seu nome por 30 dias. Seu endereço antigo redirecionará para o novo.",
    checkingNameAvailability: "Verificando disponibilidade do nome...",
    language: "Idioma",
    languageDescription: "Defina o idioma da sua publicação",
    additionalLanguages: "Idiomas adicionais",
    additionalLanguagesDescription: "Escolha quais idiomas estão disponíveis para traduções na sua publicação. Todos os idiomas estão ativados por padrão.",
    titleAndDescription: "Título e descrição",
    titleAndDescriptionDescription: "Defina o título e a descrição do seu espaço",
    yourBlogTitle: "título-da-sua-publicação",
    description: "Descrição",
    yourBlogDescription: "descrição-da-sua-publicação",
    branding: "Branding",
    brandingDescription: "Adicione a sua própria identidade visual à sua publicação e e-mails",
    logo: "Logo",
    logoDescription: "Será exibido no topo da publicação e nos e-mails. Tamanho recomendado: 200 x 200 pixels.",
    uploadLogo: "Enviar logo",
    wordmark: "Wordmark",
    wordmarkDescription: "Será exibido no lugar do nome da publicação no topo. Tamanho recomendado: 1000 x 200 pixels.",
    uploadWordmark: "Enviar wordmark",
    subscribeImage: "Imagem de assinatura",
    subscribeImageDescription: "Será exibida no formulário de assinatura. Tamanho recomendado: 600 x 600 pixels.",
    uploadSubscribeImage: "Enviar imagem de assinatura",
    favicon: "Favicon",
    faviconDescription: "Será exibido como o ícone da aba do navegador para a sua publicação. Tamanho recomendado: 128 x 128 pixels.",
    uploadFavicon: "Enviar favicon",
    header: "Cabeçalho",
    headerDescription: "Adicione um cabeçalho personalizado a cada um dos seus posts",
    footer: "Rodapé",
    footerDescription: "Adicione um rodapé personalizado a cada um dos seus posts",
    welcomeEmail: {
      title: "E-mail de boas-vindas",
      description: "Personalize o e-mail de boas-vindas enviado aos novos assinantes",
      subjectLabel: "Assunto do e-mail",
      subjectContent: "Conteúdo do e-mail",
    },
    export: {
      title: "Exportar",
      description: "Exporte todos os assinantes e o conteúdo da sua publicação",
      generateExport: "Gerar Exportação",
      generating: "Gerando...",
      exportedAt: "Exportado em",
      subscribers: "Assinantes",
      posts: "Publicações",
      download: "Baixar",
      processing: "Processando...",
      error: "Erro",
      noExports: "Ainda não há exportações",
    },
    subscribersPage: {
      email: "Email",
      subscribedAt: "Inscrito em",
      tier: "Nível",
      form: "Form",
      allForms: "All forms",
      direct: "Direct",
      free: "Grátis",
      allTiers: "Todos os níveis",
      noSubscribersFound: "Nenhum assinante encontrado",
      noSubscribersYet: "Ainda não há assinantes",
      publication: "Publicação",
      followBack: "Inscrever-se",
      following: "Inscrito",
    },
    formsPage: {
      editorTitle: "Create form",
      editEditorTitle: "Edit form",
      createForm: "Create form",
      editForm: "Edit form",
      name: "Name",
      audience: "Destinatários",
      audienceDescription: "Escolha quem pode receber o e-mail com os arquivos. Se restringir o acesso, as pessoas terão de assinar ou fazer upgrade primeiro.",
      downloads: "Files",
      subscribers: "Subscribers",
      size: "Size",
      actions: "Actions",
      everyone: "Todos",
      everyoneDescription: "Qualquer pessoa pode enviar o formulário e receber o e-mail com os arquivos.",
      subscribersOnly: "Apenas assinantes",
      subscribersOnlyDescription: "Apenas os assinantes podem receber o e-mail com os arquivos.",
      content: "Description",
      email: "Email",
      emailSubject: "Email subject",
      emailBody: "Email body",
      formSectionTitle: "Create form",
      formSectionDescription: "Set up your form and file delivery",
      filesSectionTitle: "Files",
      filesSectionDescription: "Upload the files readers will receive",
      emailSectionDescription: "Customize the delivery email sent after submit",
      defaultDescription: "Assine para receber estes arquivos por email.",
      defaultEmailSubject: "Seus arquivos estao prontos",
      defaultEmailSubjectWithName: "{publicationName}: seus arquivos estao prontos",
      defaultEmailGreeting: "Ola,",
      defaultEmailIntro: "obrigado por assinar. Seus links de download estao abaixo.",
      defaultEmailOutro: "Se tiver qualquer duvida, e so responder este email.",
      defaultEmailSignature: "- A equipe",
      defaultEmailSignatureWithName: "- {publicationName}",
      dropFiles: "Drop the files",
      formCreated: "Form created",
      formUpdated: "Form updated",
      formDeleted: "Form deleted",
      blankSlate: {
        title: "Capture, nurture, convert",
        growReadership: "Grow your readership",
        growReadershipDescription: "Capture more readers by offering exclusive content behind a subscription form.",
        convertReaders: "Convert readers into paid subscribers",
        convertReadersDescription: "Offer useful downloads and resources that turn readers into subscribers.",
        goBeyondText: "Go beyond text",
        goBeyondTextDescription: "Give your audience more by supplementing your written content with downloadable media and resources.",
      },
    },
    reactionEmojis: "Emojis de reação",
    reactionEmojisDescription: "Escolha quais emojis os leitores podem usar para reagir às suas publicações",
    addEmoji: "Adicionar emoji",
    interval: "intervalo",
    referrer: "origem",
    visitors: "visitantes",
    views: "visualizações",
    country: "país",
    channel: "canal",
  },
  categories: {
    culture: "Cultura",
    technology: "Tecnologia",
    business: "Negócios",
    usPolitics: "Política EUA",
    finance: "Finanças",
    food: "Comida",
    podcast: "Podcast",
    sports: "Esportes",
    art: "Arte",
    worldPolitics: "Política Mundial",
    healthPolitics: "Política de Saúde",
    news: "Notícias",
    fashionBeauty: "Moda & Beleza",
    music: "Música",
    faith: "Fé",
    climate: "Clima",
    science: "Ciência",
    literature: "Literatura",
    fiction: "Ficção",
    health: "Saúde",
    design: "Design",
    travel: "Viagem",
    parenting: "Parentalidade",
    philosophy: "Filosofia",
    comics: "Quadrinhos",
    international: "Internacional",
    crypto: "Cripto",
    history: "História",
    humor: "Humor",
    education: "Educação",
    filmTv: "Cinema & TV",
  },
  readerOnboarding: {
    subscribedTo: "Você se inscreveu em \"{publicationTitle}\"",
    selectInterests: "Quais temas te interessam?",
    selectInterestsDescription: "Selecione as categorias que você gostaria de ler. Isso nos ajuda a recomendar publicações que você vai adorar.",
    continue: "Continuar",
    skip: "Pular por agora",
  },
  onboarding: {
    buildAudience: "Construa a sua audiência do seu jeito",
    ownYourContent: "No Fika, você é dono do que escreve e da comunidade que se reúne em volta disso.",
    nameYourBlog: "Comece dando um nome à sua publicação; o seu cantinho na imensidão aberta da web.",
    yourBlogNamePlaceholder: "nome-da-sua-publicação",
    createBlog: "Criar publicação",
    continue: "Continuar",
    updateBlog: "Atualizar publicação",
    onboardingRabbitAlt: "Coelho de integração",
    chooseLanguage: {
      title: "Em quais idiomas você vai escrever?",
      description: "Escolha o idioma da sua publicação e ative idiomas adicionais para as traduções.",
    },
    createFirstPost: {
      title: "Publique seu primeiro artigo",
      description: "Comece a escrever seu primeiro artigo e comece com o Fika. Compartilhe seus pensamentos com o mundo!",
      descriptionWithDraft: "Continue escrevendo seu primeiro artigo e comece com o Fika. Compartilhe seus pensamentos com o mundo!",
      ignore: "Ignorar",
      createPost: "Criar Artigo",
      continueWriting: "Continuar Escrevendo",
    },
    createSecondPost: {
      title: "Publique seu segundo artigo",
      description: "Escreve outro artigo e partilha-o com os teus leitores.",
      descriptionWithDraft: "Continua a escrever o teu segundo artigo.",
      ignore: "Ignorar",
      createPost: "Criar Artigo",
      continueWriting: "Continuar Escrevendo",
      creating: "Criando...",
    },
    fillProfile: {
      title: "Complete seu perfil",
      description: "Adicione seu nome, biografia e imagem de perfil para personalizar sua presença no Fika.",
      ignore: "Ignorar",
      editProfile: "Editar Perfil",
    },
    setLanguage: {
      title: "Defina o idioma da sua publicação",
      description: "Escolha o idioma principal da sua publicação. Isso ajuda os leitores a encontrar seu conteúdo.",
      ignore: "Ignorar",
      chooseLanguage: "Escolher Idioma",
    },
    fillPublication: {
      title: "Adicione detalhes da publicação",
      description: "Dê um título, descrição e logo à sua publicação para fazê-la se destacar.",
      ignore: "Ignorar",
      editDetails: "Editar Detalhes",
    },
    translateArticles: {
      title: "Traduza \"{title}\"",
      description: "Adicione traduções aos seus artigos para alcançar leitores em diferentes idiomas.",
      ignore: "Ignorar",
      translateLatestArticle: "Traduzir artigo",
    },
  },
  postSettings: {
    title: "configurações",
    customPagesTitle: "páginas personalizadas",
    customPagesDescription: "faça este post aparecer na barra de navegação",
    customPageLabel: "página personalizada",
    seoMetadataTitle: "metadados seo",
    seoMetadataDescription: "o título e a descrição do post como aparecerão nos resultados de pesquisa",
    seoMetadataSaved: "metadados salvos",
    metaTitleLabel: "meta título",
    metaTitlePlaceholder: "título da sua publicação",
    metaDescriptionLabel: "meta descrição",
    metaDescriptionPlaceholder: "descrição da sua publicação",
    canonicalTitle: "canônico",
    canonicalDescription: "se a fonte original do post for outro site, você pode especificar a URL canônica aqui para evitar problemas de conteúdo duplicado.",
    canonicalUrlLabel: "url canônica",
    canonicalUrlSaved: "url canônica guardada",
    pinSaved: "página personalizada guardada",
    tagsTitle: "tags",
    tagsDescription: "adicione tags ao seu post",
    audienceSaved: "configurações de público salvas",
    audienceTitle: "Público",
    audienceDescription: "Escolha quem pode aceder a esta publicação.",
    audienceEveryoneLabel: "Todos",
    audienceEveryoneDescription: "Qualquer um pode ver, incluindo visitantes que não estão inscritos.",
    audienceAllSubscribersLabel: "Apenas assinantes",
    audienceAllSubscribersDescription: "Qualquer assinante pode ver esta publicação.",
    commentsEnabledTitle: "Comments",
    commentsEnabledDescription: "Allow readers to comment on this post.",
    publishedAtTitle: "data de publicação",
    publishedAtDescription: "alterar a data em que este post foi publicado pela primeira vez.",
    publishedAtLabel: "data de publicação",
    publishedAtSaved: "data de publicação salva",
    archivePostTitle: "arquivar post",
    unarchivePostTitle: "desarquivar post",
    archivePostDescription: "ocultar este post da sua publicação.",
    unarchivePostDescription: "mostrar este post na sua publicação.",
    archivePostSaved: "post arquivado",
    deletePostTitle: "apagar post",
    deletePostDescription: "remover este post completamente.",
    deletePostWarning: "esta ação não pode ser desfeita.",
    deletePostSaved: "post apagado",
    holdToDelete: "Mantém para apagar",
    deleting: "Apagando...",
    deleted: "Apagado!",
  },
  postShare: {
    preview: "Pré-visualização",
    previewDescription: "Como o seu post aparecerá nas redes sociais e nos resultados de pesquisa",
    articleLink: "Link do artigo",
    copyLink: "Copiar link",
    linkCopied: "Link copiado para a área de transferência",
    metaTitleLabel: "Meta título",
    metaTitlePlaceholder: "O título da sua publicação",
    metaDescriptionLabel: "Meta descrição",
    metaDescriptionPlaceholder: "A descrição da sua publicação",
    shareOnSocialMedia: "Partilhar nas redes sociais",
    shareOn: "Partilhar em {network}",
    publishedCongrats: "A sua publicação está online!",
    shareNow: "Agora partilhe-a com o mundo! 🚀",
    backToPost: "Voltar ao post",
    setCoverImage: "Definir como capa",
    resetCoverImage: "Restaurar ao original",
    coverImageUpdated: "Imagem de capa atualizada",
    socialImages: "Imagens para redes sociais",
    socialImagesDescription: "Baixe imagens para redes sociais",
    download: "Baixar",
  },
  postVersions: {
    title: "versões",
    loading: "a carregar versões...",
    failed: "falha ao carregar versões",
    failedVersion: "falha ao carregar versão",
    restored: "versão restaurada com sucesso",
    restore: "restaurar",
    language: "idioma",
    pills: {
      current: "atual",
      archived: "arquivada",
      sent: "enviada",
      published: "publicada",
    },
  },
  subscribe: {
    defaultText: "Assine {userName} para receber atualizações diretamente na sua caixa de entrada",
    button: "Assinar",
    emailPlaceholder: "Digite seu e-mail",
  },
  snippet: {
    placeholder: "Descreva o que você quer criar...",
    placeholderUpdate: "Descreva o que você quer alterar...",
    buttonCreate: "criar",
    buttonUpdate: "atualizar",
    buttonCreating: "Criando...",
    buttonUpdating: "Atualizando...",
  },
  auth: {
    signInOrSignUp: "Iniciar sessão",
    registrationsClosed: "Os registos estão encerrados. Os utilizadores existentes podem iniciar sessão.",
    accountSuspendedTitle: "Conta suspensa",
    accountSuspendedMessage: "A sua conta foi suspensa. Contacte humans@fika.bar se acha que isso é um erro.",
    continueWithGoogle: "Continuar com o Google",
    continueWithLinkedIn: "Continuar com o LinkedIn",
    signingIn: "Entrando...",
    or: "ou",
    enterYourEmail: "Digite o seu e-mail",
    failedToSend: "Não foi possível enviar o código de verificação. Tente novamente.",
    sending: "Enviando...",
    enterCode: "Digite o código de 6 dígitos que foi enviado para",
    verifying: "Verificando...",
    invalidCode: "Código inválido ou expirado. Tente novamente.",
    useDifferentEmail: "Usar outro e-mail",
    subscribeTo: "Assinar",
    thisBlog: "esta publicação",
    getUpdates: "Assine para receber novidades diretamente na sua caixa de entrada",
    subscribe: "Assinar",
    somethingWentWrong: "Algo deu errado",
    disclaimerPrefix: "Ao enviar, você aceita a",
    disclaimerPrivacy: "política de privacidade",
    disclaimerAnd: "e concorda com os",
    disclaimerTerms: "termos de uso",
    tierSelectionTitleSubscribed: "Você está inscrito em {publicationName}!",
    tierSelectionTitleSubscribedNoName: "Você está inscrito!",
    subscriptionError: "Ocorreu um erro. Por favor, tente novamente.",
    verifyEmailSuccess: "Email verificado com sucesso!",
    emailNotVerified: "Por favor, verifique seu email para realizar esta ação",
    subscriptionConfirmationDescriptionBeforeAuthor: "Você receberá atualizações de ",
    subscriptionConfirmationDescriptionAfterAuthor: " diretamente na sua caixa de entrada.",
    subscriptionConfirmationDescriptionNoAuthor: "Você receberá atualizações diretamente na sua caixa de entrada.",
  },
  unsubscribe: {
    writerSuccess: "você cancelou a inscrição",
    writerSuccessDescription: "você não receberá mais e-mails deste escritor. você sempre pode se inscrever novamente em seu perfil.",
    marketingSuccess: "você cancelou a inscrição",
    marketingSuccessDescription: "você não receberá mais e-mails promocionais da fika. você pode gerenciar suas preferências nas configurações.",
    weeklyFeaturedSuccess: "cancelou a inscrição",
    weeklyFeaturedSuccessDescription: "não receberá mais o email semanal de artigos em destaque. pode reativá-lo nas definições.",
    error: "algo deu errado",
    invalidToken: "este link de cancelamento de inscrição é inválido ou expirou. tente novamente a partir de um e-mail recente.",
    missingToken: "nenhum token de cancelamento de inscrição foi fornecido. use o link do seu e-mail.",
    genericError: "ocorreu um erro inesperado. tente novamente mais tarde.",
    invalidRequest: "solicitação inválida",
    invalidRequestDescription: "esta página requer um link de cancelamento de inscrição válido de um e-mail.",
    signInToManage: "entrar para gerenciar inscrições",
  },
  subscriptions: {
    title: "Assinaturas",
    manage: "Gerir",
    manageTitle: "Gerir assinaturas",
    viewOriginal: "Ver original",
    noPublishedPostsYet: "Ainda não há posts publicados",
    previousPost: "Artigo anterior",
    nextPost: "Próximo artigo",
    following: "Seguindo",
    subscribed: "Subscrito",
    renewsAt: "Renova em {date}",
    upgradePlan: "Atualizar plano",
    tierChangeError: "Falha ao mudar plano",
    manageBilling: "Faturação e recibos",
    subscribersOnly: "Apenas assinantes",
    tableOfContents: "Índice",
  },
  discover: {
    readMore: "Ler mais",
    upgradeToRead: "Atualize para ler",
    humanContent: "Humano",
    humanContentTitle: "Conteúdo humano",
    humanContentDescription: "Fika tem alta confiança de que este conteúdo foi escrito por um humano com pouca ou nenhuma assistência de IA.",
  },
  privatePost: {
    subscribeCta: "Assinar",
    upgradeCta: "Atualizar para desbloquear",
  },
  applicationLayout: {
    loadingPhrases: {
      synchronizing: "sincronizando...",
      hadronCollider: "montando o colisor de hádrons...",
      reticulatingSplines: "reticulando splines...",
      wakingHamsters: "acordando os hamsters...",
      consultingOracle: "consultando o oráculo...",
      aligningStars: "alinhando as estrelas...",
      fluxCapacitor: "calibrando o capacitor de fluxo...",
      traveling88mph: "viajando a 88 mph...",
      whiteRabbit: "seguindo o coelho branco...",
      reversingPolarity: "invertendo a polaridade...",
      enhancingImage: "melhorando a imagem...",
      enteringMatrix: "entrando na matrix...",
      findingRing: "encontrando o um anel...",
      dividingByZero: "dividindo por zero...",
    },
  },
  proofreader: {
    title: "Revisor",
    editorTitle: "Editor",
    editorDescription: "Revise seu artigo para melhorar clareza e impacto.",
    principles: {
      grammar: {
        label: "Gramática",
        description: "Corrigir erros ortográficos e gramaticais.",
        action: "Corrigir gramática",
      },
      tighten: {
        label: "Condensar",
        description: "Tornar o texto mais conciso.",
        action: "Condensar texto",
      },
      refine: {
        label: "Refinar",
        description: "Melhorar clareza, fluidez e impacto do texto.",
        action: "Refinar texto",
      },
    },
    noFixesFound: "Nenhuma correção encontrada",
    countFixes: "{{Nenhuma correção|1 correção|?? correções}}",
    countFixesFound: "{{Nenhuma correção encontrada|1 correção encontrada|?? correções encontradas}}",
    scanning: "Verificando...",
    percentComplete: "{percent}% concluído",
    discard: "Descartar",
    acceptAll: "Aceitar tudo",
    lenses: {
      title: "Lentes",
      description: "Visualize a estrutura das frases para melhorar ritmo e legibilidade.",
      off: "desligado",
      difficulty: "dificuldade",
      difficultyDescription: "Mostra quão difíceis são suas frases. Frases mais difíceis aparecem em cores mais quentes. Para melhorar, use frases mais curtas e palavras mais simples.",
      variation: "variação",
      variationDescription: "Mostra quão variados são os comprimentos das suas frases. Frases monótonas aparecem em cores mais quentes. Para melhorar, use uma mistura de frases curtas e longas.",
      legend: {
        difficulty: {
          orange: "Muito difícil de ler",
          amber: "Difícil de ler",
        },
        variation: {
          orange: "Muito monótona",
          amber: "Monótona",
        },
      },
      tips: {
        veryHard: "Esta frase é muito difícil de ler. Tente dividi-la em frases mais curtas ou usar palavras mais simples.",
        hard: "Esta frase é difícil de ler. Considere simplificá-la.",
        veryMonotonous: "Suas frases são muito semelhantes em comprimento. Varie o ritmo misturando frases curtas e longas.",
        monotonous: "Esta frase é semelhante às vizinhas. Tente variar o comprimento para melhorar o fluxo.",
      },
    },
  },
  inbox: {
    title: "Caixa de entrada",
    message: "Mensagem",
    empty: "Nenhuma carta ou comentário ainda",
    emptyLetters: "Nenhuma carta ainda",
    emptyComments: "Nenhum comentário ainda",
    emptyDescription: "Use este espaço para ver cartas dos seus leitores e conversas com autores nos quais está inscrito.",
    unread: "Não lidas",
    read: "Lidas",
    inReplyTo: "Em resposta a:",
    writeMessage: "Escreva uma mensagem...",
    submit: "Enviar",
    publishing: "Publicando...",
    you: "Você",
    tabAll: "Todos",
    tabEmails: "Cartas",
    tabComments: "Comentários",
    typePrivateEmail: "Carta privada",
    typePublicComment: "Comentário público",
    andMore: "e {count} mais",
  },
  comments: {
    title: "Comentários",
    writeComment: "Escreva um comentário...",
    submit: "Publicar comentário",
    publishing: "Publicando...",
    reply: "Responder",
    delete: "Eliminar",
    deleting: "A eliminar...",
    deleteConfirm: "Eliminar este comentário?",
    empty: "Ainda não há comentários. Seja o primeiro a comentar!",
    anonymousParticipant: "Um subscritor",
    flaggedMessage: "A sua mensagem foi sinalizada como spam ou conteúdo inadequado e não pôde ser enviada.",
    author: "Autor",
    privateVisibility: "Visível apenas para ti e os participantes",
    sendAsPrivate: "Enviar como carta privada",
    translateTo: "Traduzir para {locale}",
    showOriginal: "Mostrar original ({locale})",
  },
} satisfies Translation

export default pt
